module.exports = __webpack_public_path__ + "img/intro-screen05.3c4210a6.png";